import {DiffComponentResolver} from './types'

// import diffResolvers from 'all:part:@sanity/base/diff-resolver'
export const diffResolvers: DiffComponentResolver[] = []
